import moment from 'moment';

/**
 * Formats a date to the format 'DD MMMM YYYY - hh:mm a'.
 *
 * @param date - The date to format (Date, ISO string, or undefined).
 * @returns The formatted date string, or '- - -' when date is missing.
 */
export const formatDate = (date?: Date | string): string => {
    if (date == null || date === '') return '- - -';
    return moment(date).format('DD MMMM YYYY - hh:mm a');
};

/**
 * Formats a calendar-only date from the API (often `YYYY-MM-DDT00:00:00.000+00:00`).
 * Uses UTC so the day matches what the user chose in a date input; `formatDate` would
 * shift the calendar day in timezones behind UTC when the time is midnight Z.
 *
 * @param date - ISO string or Date
 * @returns 'DD MMMM YYYY' or '- - -' when missing
 */
export const formatCalendarDateUTC = (date?: Date | string): string => {
    if (date == null || date === '') return '- - -';
    return moment.utc(date).format('DD MMMM YYYY');
};
